/**
 * Conversion between API timestamps (ISO 8601, UTC) and the value format of
 * `<input type="datetime-local">` (`YYYY-MM-DDTHH:mm`, no zone, local wall time).
 *
 * The local components have to be read off the `Date` — `toISOString().slice(...)`
 * converts to UTC first, which shifts an evening timestamp onto the wrong day for
 * anyone east of Greenwich.
 */

const pad = (value: number) => String(value).padStart(2, "0");

/** ISO timestamp → the local wall-clock value the input element edits. */
export function toDateTimeLocal(iso: string): string {
  const date = new Date(iso);
  return (
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
    `T${pad(date.getHours())}:${pad(date.getMinutes())}`
  );
}

/**
 * Input value → ISO timestamp. A zone-less string is parsed as local time, which is
 * exactly what the editor meant by it.
 */
export function fromDateTimeLocal(value: string): string {
  return new Date(value).toISOString();
}
